import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, FormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class NgxValidationService {

  constructor() { }

  // fire form control validation
  fireFormControlValidation(control: AbstractControl) {
    control.markAsTouched();
    control.markAsDirty();
    control.updateValueAndValidity({ emitEvent: true });
  }

  // fire form group validation
  fireFormGroupValidation(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      if (formGroup.controls[key] instanceof FormArray) {
        const formsArrayControls = <FormArray>formGroup.controls[key];
        for (const formGroupControl of formsArrayControls.controls) {
          this.fireFormGroupValidation(<FormGroup>formGroupControl);
        }
      }
      // fire form control validation
      this.fireFormControlValidation(formGroup.controls[key])
    });
  }

  // fire form arra validation
  fireFormArrayValidation(formArray: FormArray) {
    formArray.controls.forEach((control: FormGroup) => {
      this.fireFormGroupValidation(control);
    });
  }

}
